import type { Always } from "../../types/experiment";
import { Badge } from "../ui/badge";

interface AlwaysFilterProps {
  value: Always;
  onChange: (value: Always) => void;
}

export function AlwaysFilter({ value, onChange }: AlwaysFilterProps) {
  return <Badge variant="outline">Always True</Badge>;
}
